import styled from 'styled-components'

export const AutoSaveIconContainer = styled.div`
  width: 30%;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const AutoSaveIconText = styled.div`
  margin-left: 8px;
  font-size: 14px;
  line-height: 16px;
  font-weight: 400;
  color: rgba(32, 32, 32, 0.7);
`
